import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {StandingsWidgetController} from "../standings-widget.controller";

export class StandingsWidgetProps extends BaseModuleProps {
  controller: StandingsWidgetController;
  collapsedCompetitorIds: Array<Number>;
}
